import {Col, Divider, Dropdown, Row, Space} from "antd";
import Logo from "./img/logo-gsg.png";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {NavLink} from "react-router-dom";
import {DownOutlined} from "@ant-design/icons";
import {Typography } from 'antd';
const { Text, Link } = Typography;

function Header() {

    const [menu, setMenu] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const items = [
        {
            label: (
                <a href="#">
                    <Text disabled>No languages available</Text>
                </a>
            ),
            key: '0',
        },
    ];

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/main-menu/?populate[Menu][populate][MainMenu]=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        const content = response.data.data.attributes;

        setMenu(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (
        <Row style={{background: "#fff", display: "flex"}} >
            <Col span={24}>
                <Row className={"Header"}
                     style={{
                         maxWidth: '1280px',
                         padding: '0 48px'
                     }}
                >
                    <Col
                         xs={24} sm={24} md={6} lg={6}
                         style={{
                             display: 'flex',
                             minHeight: '120px',
                             alignItems: 'center',
                         }}
                    >
                        <NavLink to={'/'} style={{display: 'flex', alignItems: 'center', margin: 0, textDecoration: 'none'}}>
                            <img src={Logo}
                                 alt={'Global Solutions Group logo'}
                                 style={{
                                     maxHeight: '40px',
                                     marginRight: '8px'
                            }}
                            />
                            <span>GLOBAL SOLUTIONS GROUP</span>
                        </NavLink>

                    </Col>
                    <Col
                         xs={24}
                         sm={24}
                         md={18}
                         lg={18}

                         style={{
                             display: 'flex',
                             minHeight: '120px',
                             alignItems: 'center',
                             justifyContent: 'right',
                         }}>
                        {
                            (menu?.Menu?.MainMenu ?? []).map((item, value) => {
                                return <NavLink key={value} to={item.URL}>{item.MenuTitle}</NavLink>
                            })
                        }
                        <Dropdown menu={{ items }} trigger={['click']}>
                            <a style={{marginLeft: 32}} onClick={e => e.preventDefault()}>
                                <Space>
                                    <span className={"fi fi-gb"}></span>
                                    <DownOutlined />
                                </Space>
                            </a>
                        </Dropdown>
                    </Col>
                </Row>
                <Divider style={{margin: '0px'}}/>
            </Col>
        </Row>
    )
}

export default Header